module.exports = __webpack_public_path__ + "img/Scanvaegt1.3f13421e.png";